module.exports = __webpack_public_path__ + "static/img/5.ba5c5586.jpg";